import { IndustrialProcessSchema, IndustrialProcessType, SurfaceTreatmentTypeType } from "../types";

export type OnboardingProcessStepTarget = "MACHINE" | "SURFACE_TREATMENT";

export function resolveOnboardingProcessStepTarget(
  industrialProcess: IndustrialProcessType | null,
  type: SurfaceTreatmentTypeType,
): OnboardingProcessStepTarget | null {
  if (!industrialProcess) {
    return null;
  }
  if (industrialProcess === IndustrialProcessSchema.enum.SURFACE_TREATMENT) {
    return "SURFACE_TREATMENT";
  }
  return type === "OUTSOURCING" ? "SURFACE_TREATMENT" : "MACHINE";
}
